import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'components/heading';
import Link from 'components/link';
import Image from 'components/image';
import HousingProjectInformationList from 'components/housing-project-information-list';

const HousingProjectListWithIconItem = ({ image, title, text, link }) => {
  return (
    <div className="housing-project-list-with-icons-block__wrapper">
      {image && (
        <div className="housing-project-list-with-icons-block__item-image">
          <Image {...image} />
        </div>
      )}

      {title || text ? (
        <div className="housing-project-list-with-icons-block__item-text-content">
          {title && (
            <div className="housing-project-list-with-icons-block__item-title">
              <Heading level={3} theme={Heading.themes.h2}>
                {title}
              </Heading>
            </div>
          )}
          {text && (
            <div className="housing-project-list-with-icons-block__item-text">
              {text}
            </div>
          )}
        </div>
      ) : null}
      {link && (
        <Link
          className="housing-project-list-with-icons-block__item-link"
          color="black"
          animation="shrink"
          {...link}
        />
      )}
    </div>
  );
};

HousingProjectListWithIconItem.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  table: PropTypes.exact(HousingProjectInformationList.propTypes),
  link: PropTypes.exact(Link.propTypes),
  image: PropTypes.exact(Image.propTypes)
};
export default HousingProjectListWithIconItem;
